module.exports = __webpack_public_path__ + "static/media/portrait.20e6e7f0.jpg";